module.exports = __webpack_public_path__ + "static/media/gerar_password.2aeaaf98.svg";